import reducer from './briefings.reducer';
import actions from './briefings.actions';
import selectors from './briefings.selectors';

export default {
  reducer,
  actions,
  selectors,
};
